import getRelayEnvironment from '../../../relayClientEnvironment';
import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeProgramAnnouncementModal() {
    return import(/* webpackChunkName: "TradeProgramAnnouncementModalChunk" */
    '../../../TradeProgramAnnouncementModal/TradeProgramAnnouncementModal').then(
        mod => mod.TradeProgramAnnouncementModal
    );
}

export const tradeProgramAnnouncementModalAction = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeProgramAnnouncementModal,
        containerClassName: 'tradeGeneralOnboardingContainer',
        props: {
            openOnRender: true,
            environment: getRelayEnvironment(),
        },
    });
    return dispatch({ type: customActionType.actionType });
};
